import { Flex, SlideFade } from '@chakra-ui/react'

export const Layout = ({ children }) => {
  return (
    <Flex direction='column' mt='1rem'>
      <SlideFade in>{children}</SlideFade>
    </Flex>
  )
}
